var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBerries(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C5.34315 14 4 15.3432 4 17C4 18.6569 5.34315 20 7 20C8.65685 20 10 18.6569 10 17C10 15.3432 8.65685 14 7 14ZM2 17C2 14.2386 4.23858 12 7 12C9.76142 12 12 14.2386 12 17C12 19.7614 9.76142 22 7 22C4.23858 22 2 19.7614 2 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 16C16.1193 16 15 17.1193 15 18.5C15 19.8807 16.1193 21 17.5 21C18.8807 21 20 19.8807 20 18.5C20 17.1193 18.8807 16 17.5 16ZM13 18.5C13 16.0147 15.0147 14 17.5 14C19.9853 14 22 16.0147 22 18.5C22 20.9853 19.9853 23 17.5 23C15.0147 23 13 20.9853 13 18.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4562 4.7073C19.6179 5.2354 19.3208 5.79455 18.7927 5.95622C14.6599 7.22137 11.5215 9.88877 9.92848 13.8714C9.72336 14.3842 9.14139 14.6336 8.62861 14.4285C8.11583 14.2234 7.86641 13.6414 8.07152 13.1286C9.91224 8.52683 13.5567 5.46748 18.2073 4.04382C18.7354 3.88216 19.2945 4.17921 19.4562 4.7073Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1461 4.23689C19.5676 4.59382 19.6199 5.22482 19.263 5.64627C18.776 6.22124 17.8015 7.70189 17.5064 9.36886C17.041 11.9983 17.4845 13.519 17.9283 14.6286C18.1334 15.1414 17.884 15.7234 17.3712 15.9285C16.8584 16.1336 16.2765 15.8841 16.0714 15.3713C15.5153 13.981 14.9954 12.0806 15.5371 9.02028C15.9134 6.89405 17.1071 5.0972 17.7367 4.35372C18.0937 3.93227 18.7247 3.87996 19.1461 4.23689Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2407 1.34923C14.6002 0.929901 15.2315 0.881339 15.6508 1.24076L22.6508 7.24076C23.0701 7.60018 23.1187 8.23148 22.7593 8.65081C22.3998 9.07014 21.7685 9.1187 21.3492 8.75927L14.3492 2.75927C13.9299 2.39985 13.8813 1.76855 14.2407 1.34923Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerries);
export default __webpack_public_path__ + "static/media/berries.9849f7cd95d2f337cbb2f9c0a17b880c.svg";
export { ForwardRef as ReactComponent };